import { IconButton, Button, Grid, makeStyles } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { useState } from "react"
import BeenhereIcon from '@material-ui/icons/Beenhere'
import { aprobarFacturaction, obtenerFacturasAceptadasAction, cargarFacturaAction } from "../../../ducks/facturacionAceptadasDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import UploadInput from "./../../../global/UploadInput";
import { getBase64 } from "./../../../utils/fileBase64";

export const FPagarItemStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2%"
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "1160px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "1160px",
        minWidth: "500px",
    },
}))

const ButtonAprovarFactura = (props) => {
    const { IdFactura } = props
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()
    const classes = FPagarItemStyle()
    const [file, setFile] = useState([]);

    const handleClose = () => {
        setOpen(false)
    }
    const onSend = () => {
        if (file.length <= 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Seleccione por lo menos un archivo.",
            })
            return null
        }
        dispatch(onLoadAnction({ message: "Esto puede tardar varios minutos..." }))
        dispatch(aprobarFacturaction({ IdFactura: IdFactura })).then(Response => {
            if (Response?.status === 500) {
                dispatch(offLoadAction())
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                dispatch(offLoadAction())
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }

            file.forEach(async (archivo) => {
                await getBase64(archivo).then((result) => {
                    const Logobase64 = String(result).split(",")[1];
                    let payload = {
                        IdFactura: IdFactura,
                        Nombre: `${archivo.name.split(".")[0]}`,
                        Imagen: Logobase64,
                        Extension:
                            archivo.name.split(".")[archivo.name.split(".").length - 1],
                    }
                    dispatch(cargarFacturaAction(payload)).then((Response) => {
                        dispatch(offLoadAction())

                        if (Response?.status === 500) {
                            ToastMessage.fire({
                                icon: "warning",
                                title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                            });
                            return null
                        }
                        if (Response?.status === 400) {
                            ToastMessage.fire({
                                icon: "warning",
                                title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                            });
                            return null
                        }
                        dispatch(obtenerFacturasAceptadasAction())
                        handleClose()
                        ToastMessage.fire({
                            icon: "success",
                            title: "Ingreso Correcto",
                        })
                    })
                })
            })
        })
    }
    const handleClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton aria-label="Aprovar" onClick={handleClick} color="secondary" >
                <BeenhereIcon />
            </IconButton>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Cargar factura"
                />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <UploadInput
                            files={file}
                            accept='.pdf,.jpg,.png,.jpeg'
                            isPreview={false}
                            multiple={true}
                            setFiles={setFile}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            onClick={onSend}
                        >
                            Aprovado
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default ButtonAprovarFactura